import { render, staticRenderFns } from "./AnxLink.vue?vue&type=template&id=798c4a06&scoped=true&"
import script from "./AnxLink.vue?vue&type=script&lang=ts&"
export * from "./AnxLink.vue?vue&type=script&lang=ts&"
import style0 from "./AnxLink.vue?vue&type=style&index=0&id=798c4a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c4a06",
  null
  
)

export default component.exports